import React, { useRef, useEffect } from "react";

export default function Marquee({ children, speed = 1.3 }) {
    const containerRef = useRef(null);

    useEffect(() => {
        let x = 0;
        let animationFrameId;

        const step = () => {
            x -= speed;
            const el = containerRef.current;
            if (el) {
                const totalWidth = el.scrollWidth / 2;
                if (-x >= totalWidth) x = 0; // reset invisibly
                el.style.transform = `translateX(${x}px)`;
            }
            animationFrameId = requestAnimationFrame(step);
        };

        animationFrameId = requestAnimationFrame(step);
        return () => cancelAnimationFrame(animationFrameId);
    }, [speed]);

    return (
        <div className="overflow-hidden whitespace-nowrap">
            <div ref={containerRef} className="flex items-center gap-5 will-change-transform">
                {children}
                {children /* duplicate for looping */}
            </div>
        </div>
    );
}
